export default __webpack_public_path__ + "static/media/bg1.b84d2ed6.jpg";